<div class="w-full flex flex-col flex-1 min-h-0">
<div class="flex flex-col flex-1 min-h-0 overflow-hidden">

  <!-- Primera carga: tabla Skeleton -->
  @if (loading() && !initialLoadDone()) {
    <div class="flex-1 min-h-0 flex flex-col bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
      <div class="px-6 py-5 border-b border-slate-200 bg-slate-50/50 shrink-0">
        <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div>
            <p-skeleton width="8rem" height="1.5rem" class="mb-2" />
            <p-skeleton width="14rem" height="0.875rem" />
          </div>
            <div class="w-full sm:w-auto flex justify-end">
              <p-skeleton width="10rem" height="2.5rem" />
            </div>
        </div>
      </div>
      <div class="flex-1 min-h-0 overflow-auto">
        <table class="w-full border-collapse">
          <thead class="bg-slate-50 border-b border-slate-200">
            <tr>
              <th>Cliente</th>
              <th>Tipo</th>
              <th>RFC</th>
              <th>Email</th>
              <th>Teléfono</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-slate-100">
            @for (row of skeletonRows; track row) {
              <tr>
                <td class="px-2 py-2"><div class="flex items-center gap-2"><p-skeleton shape="circle" size="2.5rem" /><p-skeleton width="7rem" height="0.875rem" /><p-skeleton width="5rem" height="0.75rem" class="mt-1" /></div></td>
                <td class="px-2 py-2"><p-skeleton width="4rem" height="1.25rem" /></td>
                <td class="px-2 py-2 w-[90px]"><p-skeleton width="5rem" height="0.875rem" /></td>
                <td class="px-2 py-2"><p-skeleton width="8rem" height="0.875rem" /></td>
                <td class="px-2 py-2 w-[90px]"><p-skeleton width="5rem" height="0.875rem" /></td>
                <td class="px-2 py-2 w-[90px]"><p-skeleton width="4rem" height="1.25rem" /></td>
                <td class="px-2 py-2 text-right w-[100px]"><p-skeleton width="4rem" height="2rem" /></td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <div class="bg-slate-50 px-6 py-4 border-t border-slate-200 flex justify-end shrink-0">
        <p-skeleton width="12rem" height="2rem" />
      </div>
    </div>
  }

  <!-- Error State -->
  @if (error() && !loading()) {
    <div class="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
      <div class="flex items-center">
        <mat-icon class="text-red-600 mr-2">error</mat-icon>
        <p class="text-red-800">{{ error() }}</p>
      </div>
      <button 
        (click)="loadCustomers()" 
        class="mt-3 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors">
        Reintentar
      </button>
    </div>
  }

  <!-- Tabla PrimeNG: siempre visible tras primera carga (con filtros) para poder seguir filtrando aunque no haya resultados -->
  @if (initialLoadDone() && !error()) {
    <div class="flex-1 min-h-0 flex flex-col">
      <div class="flex-1 min-h-0 flex flex-col bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
        <div class="px-6 py-5 border-b border-slate-200 bg-slate-50/50 shrink-0">
          <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <div>
              <h2 class="text-lg font-semibold text-slate-900 flex items-center gap-2">
                <span class="flex h-9 w-9 items-center justify-center rounded-lg bg-sky-100 text-sky-600">
                  <i class="pi pi-users"></i>
                </span>
                Clientes
              </h2>
              <p class="text-sm text-slate-500 mt-1">Catálogo de clientes registrados.</p>
            </div>
            <div class="w-full sm:w-auto flex flex-wrap items-center justify-end gap-2">
              <a routerLink="/customers/nuevo" class="inline-block" appDisableUnless="CUSTOMER_WRITE">
                <p-button label="Nuevo cliente" icon="pi pi-plus" severity="primary" size="small" appDisableUnless="CUSTOMER_WRITE" />
              </a>
            </div>
          </div>
        </div>

        <div [formGroup]="filtersForm" class="border-b border-slate-200 bg-slate-50 shrink-0 px-3 py-2">
          <div class="grid grid-cols-2 sm:flex sm:flex-wrap sm:items-end gap-2">
            <div class="min-w-0 col-span-2 sm:flex-1 sm:min-w-40">
              <p-floatlabel class="w-full" variant="on">
                <p-iconfield class="w-full">
                  <p-inputicon class="pi pi-search text-sm" />
                  <input pInputText id="filterCustomersQ" formControlName="q" class="w-full p-inputtext-sm" autocomplete="off" />
                  @if (filtersForm.controls.q.value) {
                    <p-inputicon class="pi pi-times text-sm cursor-pointer" (click)="filtersForm.controls.q.setValue('', { emitEvent: false }); applyFilters()" />
                  }
                </p-iconfield>
                <label for="filterCustomersQ">Nombre, razón social o RFC</label>
              </p-floatlabel>
            </div>
            <p-floatlabel class="w-full min-w-0 sm:w-32" variant="on">
              <p-select
                formControlName="type"
                inputId="filterCustomersType"
                [options]="typeFilterOptions"
                optionLabel="label"
                optionValue="value"
                size="small"
                [showClear]="true"
                class="w-full" />
              <label for="filterCustomersType">Tipo</label>
            </p-floatlabel>
            <p-floatlabel class="w-full min-w-0 sm:w-32" variant="on">
              <p-select
                formControlName="state"
                inputId="filterCustomersState"
                [options]="stateFilterOptions"
                optionLabel="label"
                optionValue="value"
                size="small"
                [showClear]="true"
                class="w-full" />
              <label for="filterCustomersState">Estado</label>
            </p-floatlabel>
            @if (hasActiveFilters()) {
              <div class="flex items-end">
                <p-button
                  icon="pi pi-times"
                  [rounded]="true"
                  [text]="true"
                  size="small"
                  severity="secondary"
                  type="button"
                  (onClick)="clearFilters()"
                  ariaLabel="Limpiar filtros" />
              </div>
            }
          </div>
        </div>

        <div class="flex-1 min-h-0 overflow-hidden">
          <p-table
            #dt2
            [value]="customers()"
            dataKey="id"
            [lazy]="true"
            [scrollable]="true"
            scrollHeight="flex"
            [totalRecords]="totalItems()"
            [first]="currentPage() * pageSize()"
            [rows]="pageSize()"
            [rowsPerPageOptions]="pageSizeOptions"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} clientes"
            [loading]="loading()"
            [paginator]="true"
            sortMode="single"
            [sortField]="sortField()"
            [sortOrder]="sortOrder()"
            (onLazyLoad)="onLazyLoad($event)"
            [globalFilterFields]="['comercialName', 'legalName', 'taxId', 'type', 'state']"
            [tableStyle]="{ width: '100%' }"
            styleClass="customers-primeng-table p-datatable-striped p-datatable-sm"
            [rowHover]="true"
            paginatorStyleClass="!border-0 !bg-transparent !pt-4 !flex !justify-end"
          >
            <ng-template pTemplate="header">
              <tr class="">
                <th class="!px-2 min-w-[150px] max-w-[250px]" pSortableColumn="legalName">
                  <span class="inline-flex items-center justify-between gap-1.5 w-full">
                    <span>Cliente</span>
                    @if (sortField() === 'legalName') {
                      <p-sortIcon field="legalName" />
                    }
                  </span>
                </th>
                <th class="!px-2 !whitespace-nowrap" pSortableColumn="type">
                  <span class="inline-flex items-center justify-between gap-1.5 w-full">
                    <span>Tipo</span>
                    @if (sortField() === 'type') {
                      <p-sortIcon field="type" />
                    }
                  </span>
                </th>
                <th class="!px-2 !whitespace-nowrap" pSortableColumn="taxId">
                  <span class="inline-flex items-center justify-between gap-1.5 w-full">
                    <span>RFC</span>
                    @if (sortField() === 'taxId') {
                      <p-sortIcon field="taxId" />
                    }
                  </span>
                </th>
                <th class="!px-2" pSortableColumn="email">
                  <span class="inline-flex items-center justify-between gap-1.5 w-full">
                    <span>Email</span>
                    @if (sortField() === 'email') {
                      <p-sortIcon field="email" />
                    }
                  </span>
                </th>
                <th class="!px-2 !whitespace-nowrap" pSortableColumn="phone">
                  <span class="inline-flex items-center justify-between gap-1.5 w-full">
                    <span>Teléfono</span>
                    @if (sortField() === 'phone') {
                      <p-sortIcon field="phone" />
                    }
                  </span>
                </th>
                <th class="!px-2 !whitespace-nowrap" pSortableColumn="state">
                  <span class="inline-flex items-center justify-between gap-1.5 w-full">
                    <span>Estado</span>
                    @if (sortField() === 'state') {
                      <p-sortIcon field="state" />
                    }
                  </span>
                </th>
                <th class="!px-2 !whitespace-nowrap !text-right">Acciones</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-customer>
              <tr class="cursor-pointer hover:!bg-sky-50/50 transition-colors !border-slate-100" (click)="openCustomerDetails(customer)">
                <td class="!px-2 !py-2 !border-slate-100 min-w-[150px] max-w-[250px] overflow-hidden">
                  <div class="flex items-center gap-2 min-w-0">
                    <div class="shrink-0 h-8 w-8 rounded-full flex items-center justify-center text-slate-600 [&>i]:text-sm"
                      [class.bg-blue-100]="customer.type === CompanyTypeEnum.PERSON"
                      [class.bg-purple-100]="customer.type === CompanyTypeEnum.COMPANY"
                      [class.text-blue-600]="customer.type === CompanyTypeEnum.PERSON"
                      [class.text-purple-600]="customer.type === CompanyTypeEnum.COMPANY">
                      <i [class]="customer.type === CompanyTypeEnum.PERSON ? 'pi pi-user' : 'pi pi-building'"></i>
                    </div>
                    <div class="min-w-0">
                      <div class="text-sm font-medium text-slate-900 truncate">{{ customer.comercialName }}</div>
                      <div class="text-xs text-slate-500 truncate">{{ customer.legalName }}</div>
                    </div>
                  </div>
                </td>
                <td class="!px-2 !py-2 !border-slate-100 text-sm text-slate-700 !whitespace-nowrap">
                  <span class="px-2 py-1 text-xs font-medium rounded-full"
                    [class.bg-blue-100]="customer.type === CompanyTypeEnum.PERSON"
                    [class.text-blue-800]="customer.type === CompanyTypeEnum.PERSON"
                    [class.bg-purple-100]="customer.type === CompanyTypeEnum.COMPANY"
                    [class.text-purple-800]="customer.type === CompanyTypeEnum.COMPANY">
                    {{ getCompanyTypeLabel(customer.type) }}
                  </span>
                </td>
                <td class="!px-2 !py-2 !border-slate-100 text-sm !whitespace-nowrap">{{ customer.taxId }}</td>
                <td class="!px-2 !py-2 !border-slate-100 text-sm">{{ customer.email }}</td>
                <td class="!px-2 !py-2 !border-slate-100 text-sm !whitespace-nowrap">{{ customer.phone }}</td>
                <td class="!px-2 !py-2 !border-slate-100 !whitespace-nowrap">
                  <p-tag class="!text-xs" [value]="customer.state === 'ACTIVE' ? 'Activo' : 'Inactivo'" [severity]="getStateSeverity(customer.state) ?? undefined" />
                </td>
                <td class="!px-2 !py-2 !border-slate-100 !text-right !whitespace-nowrap" (click)="$event.stopPropagation()" pFrozenColumn >
                  <span class="inline-flex items-center gap-0.5">
                    <p-button icon="pi pi-pen-to-square" rounded [text]="true" severity="secondary" styleClass="hover:!bg-sky-100" (onClick)="editCustomer(customer, $event)" appDisableUnless="CUSTOMER_WRITE" />
                    <p-button icon="pi pi-trash" rounded [text]="true" severity="danger" (onClick)="openDeleteModal(customer, $event)" appDisableUnless="CUSTOMER_DELETE" />
                  </span>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="7" class="!px-2 !py-12 !text-center !text-slate-500 !border-slate-100">
                  No se encontraron clientes con los filtros aplicados.
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  }

</div>

  @if (deleteModalOpen()) {
    <div class="fixed inset-0 z-50 flex items-center justify-center">
      <div class="absolute inset-0 bg-black transition-opacity duration-300 ease-out"
        [class.bg-opacity-50]="deleteModalShown()" [class.bg-opacity-0]="!deleteModalShown()"
        (click)="closeDeleteModal()"></div>
      <div class="relative bg-white rounded-xl shadow-xl w-full max-w-md p-6 z-10 transform transition-all duration-300 ease-out"
        [class.opacity-100]="deleteModalShown()" [class.opacity-0]="!deleteModalShown()"
        [class.scale-100]="deleteModalShown()" [class.scale-95]="!deleteModalShown()">
        <div class="flex items-center justify-between mb-4">
          <h3 class="text-lg font-semibold text-slate-900">Confirmar eliminación</h3>
          <button type="button" class="text-slate-500 hover:text-slate-700" (click)="closeDeleteModal()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <p class="text-sm text-slate-600 mb-6">
          ¿Está seguro de eliminar el cliente "{{ customerToDelete()?.comercialName || customerToDelete()?.legalName }}"? Esta acción no se puede deshacer.
        </p>
        <div class="flex justify-end gap-3">
          <button type="button" mat-stroked-button (click)="closeDeleteModal()">Cancelar</button>
          <button type="button" mat-raised-button color="warn" [disabled]="deleteLoading()"
            (click)="confirmDeleteCustomer()">
            {{ deleteLoading() ? 'Eliminando...' : 'Eliminar' }}
          </button>
        </div>
      </div>
    </div>
  }

  <p-drawer
    [visible]="isDetailsOpen()"
    position="right"
    (visibleChange)="onDrawerVisibleChange($event)"
    styleClass="customer-details-drawer !w-[800px]"
    [blockScroll]="true">
    <ng-template pTemplate="header">
      <div class="flex items-center justify-between w-full gap-3">
        <div class="flex items-center gap-3 min-w-0">
          <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-sky-100 text-sky-600 shadow-sm">
            <i class="pi pi-user text-base"></i>
          </span>
          <h3 class="text-lg font-semibold text-slate-900">Detalles del cliente</h3>
        </div>
        @if (selectedCustomer() && !detailsLoading()) {
          <button
            type="button"
            class="inline-flex items-center gap-2 text-sm font-semibold bg-blue-600 text-white px-3 py-2 rounded-lg shadow-sm hover:bg-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 shrink-0"
            (click)="editFromModal()">
            <i class="pi pi-pencil text-sm"></i>
            Editar
          </button>
        }
      </div>
    </ng-template>
    @if (detailsLoading()) {
      <div class="flex flex-col items-center justify-center py-12 gap-4">
        <i class="pi pi-spin pi-spinner text-4xl text-sky-500"></i>
        <p class="text-sm text-slate-600">Cargando cliente...</p>
      </div>
    } @else if (selectedCustomer()) {
      <app-customer-read
        [customer]="selectedCustomer()!"
        (openSale)="openSaleDetails($event)" />
    }
  </p-drawer>

  <p-drawer
    [visible]="isSaleDetailsOpen()"
    position="right"
    (visibleChange)="onSaleDrawerVisibleChange($event)"
    styleClass="customer-sale-drawer !w-[800px]"
    [blockScroll]="true">
    <ng-template pTemplate="header">
      <div class="flex items-center justify-between w-full gap-3">
        <div class="flex items-center gap-3 min-w-0">
          <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-violet-100 text-violet-600 shadow-sm">
            <i class="pi pi-shopping-cart text-base"></i>
          </span>
          <h3 class="text-lg font-semibold text-slate-900">Detalle de venta</h3>
        </div>
        @if (selectedSale() && !saleDetailsLoading()) {
          <button
            type="button"
            class="inline-flex items-center gap-2 text-sm font-semibold bg-blue-600 text-white px-3 py-2 rounded-lg shadow-sm hover:bg-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 shrink-0"
            (click)="editSaleFromModal()">
            <i class="pi pi-pencil text-sm"></i>
            Editar
          </button>
        }
      </div>
    </ng-template>
    @if (saleDetailsLoading()) {
      <div class="flex flex-col items-center justify-center py-12 gap-4">
        <i class="pi pi-spin pi-spinner text-4xl text-sky-500"></i>
        <p class="text-sm text-slate-600">Cargando venta...</p>
      </div>
    } @else if (selectedSale()) {
      <app-sale-read
        [sale]="selectedSale()!"
        [charges]="saleCharges()"
        (openCustomer)="openCustomerFromSale($event)"
        (openSubscription)="openSubscriptionFromSale($event)" />
    }
  </p-drawer>

  <p-drawer
    [visible]="isSubscriptionDetailsOpen()"
    position="right"
    (visibleChange)="onSubscriptionDrawerVisibleChange($event)"
    styleClass="customer-subscription-drawer !w-[800px]"
    [blockScroll]="true">
    <ng-template pTemplate="header">
      <div class="flex items-center justify-between w-full gap-3">
        <div class="flex items-center gap-3 min-w-0">
          <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-teal-100 text-teal-600 shadow-sm">
            <i class="pi pi-sync text-base"></i>
          </span>
          <h3 class="text-lg font-semibold text-slate-900">Detalle de suscripción</h3>
        </div>
        @if (selectedSubscription() && !subscriptionDetailsLoading()) {
          <button
            type="button"
            class="inline-flex items-center gap-2 text-sm font-semibold bg-blue-600 text-white px-3 py-2 rounded-lg shadow-sm hover:bg-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 shrink-0"
            (click)="editSubscriptionFromModal()">
            <i class="pi pi-pencil text-sm"></i>
            Editar
          </button>
        }
      </div>
    </ng-template>
    @if (subscriptionDetailsLoading()) {
      <div class="flex flex-col items-center justify-center py-12 gap-4">
        <i class="pi pi-spin pi-spinner text-4xl text-teal-500"></i>
        <p class="text-sm text-slate-600">Cargando suscripción...</p>
      </div>
    } @else if (selectedSubscription()) {
      <app-subscription-read
        [subscription]="selectedSubscription()!"
        (openSale)="openSaleDetails($event)" />
    }
  </p-drawer>
</div>
